module.exports = __webpack_public_path__ + "static/media/copy.36e2112a.svg";